package com.xtream.ui.tv.presentation.tvchannels

import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.tween
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusProperties
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.focus.focusRestorer
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.input.key.KeyEvent
import androidx.compose.ui.input.key.KeyEventType
import androidx.compose.ui.input.key.key
import androidx.compose.ui.input.key.onKeyEvent
import androidx.compose.ui.input.key.type
import androidx.compose.ui.layout.layout
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.platform.LocalFocusManager
import androidx.compose.ui.platform.LocalLayoutDirection
import androidx.compose.ui.platform.LocalWindowInfo
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.LayoutDirection
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.xtream.composeapp.LocalAppViewModelStoreOwner
import com.xtream.composeapp.LocalSnackbarHostState
import com.xtream.composeapp.data.Screen
import com.xtream.composeapp.presentation.ui.tvchannels.TvCategoriesTvList
import com.xtream.composeapp.presentation.ui.tvchannels.TvChannelsTvList
import com.xtream.composeapp.presentation.widget.BackHandler
import com.xtream.composeapp.viewmodel.AppSettingsViewModel
import com.xtream.composeapp.viewmodel.UserViewModel
import com.xtream.composeapp.viewmodel.livetv.StreamControlViewModel
import com.xtream.data_kmp.AllConst
import com.xtream.data_kmp.XtreamUtils
import com.xtream.data_kmp.dto.LiveCategory
import com.xtream.data_kmp.util.extension.safeEncodeToString
import com.xtream.data_kmp.util.extension.toLiveStreamOrNull
import com.xtream.sharedResources.resources.Res
import com.xtream.sharedResources.resources.tv_channels
import com.xtream.ui.ui.widget.ConfigureDialogWindowProperties
import com.xtream.video_player.BaseComposeMedia3Player
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import kotlinx.coroutines.withContext
import kotlinx.serialization.json.Json
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel


@Composable
fun TestNewTvChannelsPlayerScreen(){
    NewTvChannelsPlayerScreen( streamId = null, categoryId = 1, navKey = Screen.MenuLiveStreamPlayer(null,null,null))
}

@Composable
fun NewTvChannelsPlayerScreen(
    streamId: Int?,
    categoryId: Int?,
    modifier: Modifier = Modifier,
    requestFocusOnStart: Boolean = false,
    title: String? =null,
    streamControlViewModel: StreamControlViewModel = koinViewModel(),
    userInfViewModel: UserViewModel = koinViewModel(),
    appSettingsViewModel: AppSettingsViewModel = koinViewModel(),
    onEnterFullScreen: () -> Unit = {},
    onExitFullScreen: () -> Unit = {},
    layoutWidth: Dp =  with(LocalDensity.current) {
        LocalWindowInfo.current.containerSize.width.toDp() - 60.dp
       // LocalConfiguration.current.screenWidthDp.toDp() - 60.dp

                              },
    navKey: Screen,
    mainLayoutStartPadding: Dp =24.dp
                              ) {


    val viewModelStoreOwner =LocalAppViewModelStoreOwner.current// activity as ViewModelStoreOwner
    val accountState by userInfViewModel.loggedInUserFlow.collectAsStateWithLifecycle(null)
    val playBackExt by appSettingsViewModel.liveStreamFormatFlow.collectAsStateWithLifecycle(null)



    val streamState by streamControlViewModel.selectedChannel.collectAsStateWithLifecycle()



    val uri by remember(accountState, streamState, playBackExt) {
        derivedStateOf {
            XtreamUtils.buildStreamUrl(accountState, streamState, playBackExt)
        }
    }
    val categoriesUiState: List<LiveCategory> by streamControlViewModel
        .liveCategoriesFlow
        .collectAsStateWithLifecycle(emptyList())

    val isFavorite by streamControlViewModel.isFavoriteFlow(streamState)
        .collectAsStateWithLifecycle(false)
    val playingCategoryState by streamControlViewModel.playingCategory.collectAsStateWithLifecycle()


    var panelState by remember { mutableStateOf(PanelState.WithChannels) }
    val isFullScreen =
        panelState == PanelState.PlayerOnly || panelState == PanelState.PlayerWithController


    LaunchedEffect(panelState) {
        if (panelState == PanelState.PlayerOnly) {

            with(streamControlViewModel) {
                emitPlayingCategory(playingCategory.value)
            }
        }

    }

    LaunchedEffect(isFullScreen) {
        if (isFullScreen)
            onEnterFullScreen()
        else
            onExitFullScreen()
    }




    var resetVisibility: (() -> Unit)? = null

    val scope = rememberCoroutineScope()
    val snackbarHostState = LocalSnackbarHostState.current

    fun changePlayBackBy(number: Int) {

        scope.launch {          //get items count
            val itemCount = withContext(Dispatchers.Default) {
                streamControlViewModel.playingCategorySize() ?: 0
            }//tvChannelsUiState?.size?:0

            if (itemCount == 0L) return@launch
            //get selected position
            val currentPosition = streamControlViewModel.selectedPosition.value

           // val selectedPosition = (currentPosition + number + itemCount) % itemCount
            //update selected position
            streamControlViewModel.updateSelectedBy(addBy = number)
            if (panelState == PanelState.PlayerOnly) {
                panelState = PanelState.PlayerWithController
                resetVisibility?.invoke()

            }
        }

    }


    fun keyEvent(event: KeyEvent): Boolean {
        // 1. Extract platform-agnostic key and type descriptors
        val currentKey = event.key
        val eventType = event.type

        // 2. Early return guard checks utilizing KMP Key tokens
        if (eventType == KeyEventType.KeyUp ||
            currentKey == Key.Back ||
            currentKey == Key.Escape ||
            (panelState != PanelState.PlayerOnly && panelState != PanelState.PlayerWithController)
        ) {
            return false
        }

        // Ping visibility reset callback on valid navigation presses
        resetVisibility?.invoke()

        // 3. Process common directional keys for playback manipulation
        return when (currentKey) {
            Key.DirectionDown -> {
                changePlayBackBy(-1)
                true
            }

            Key.DirectionUp -> {
                changePlayBackBy(1)
                true
            }

            else -> false
        }
    }

val playerFocusRequester = remember { FocusRequester() }
val tvChannelsFocusRequester = remember { FocusRequester() }

val localFocusManager = LocalFocusManager.current

    // 1. Get screen dimensions once (Static - doesn't trigger subcomposition)
    val configuration = LocalWindowInfo.current

//val videoRenderMode = appSettingsViewModel.videoRenderModeFlow.collectAsStateWithLifecycle(null)
// 1. Change to a 0f to 1f progress value to avoid DP-to-Pixel math in every frame
    val playerExpansionProgress by animateFloatAsState(
        targetValue = if (isFullScreen) 1f else 0f,
        animationSpec = tween(durationMillis = 600),
        label = "PlayerExpansion",
        finishedListener = {
            if (!isFullScreen) {
                //playerFocusRequester.freeFocus()
            } else {
                playerFocusRequester.requestFocus()
               // playerFocusRequester.captureFocus()
            }
        }
    )



    val slideProgress by animateFloatAsState(
        targetValue = if (isFullScreen) .15f else 0f,
        animationSpec = tween(durationMillis = 1000),
        label = "ChannelSlideProgress"
    )
    val alphaValue by animateFloatAsState(
        targetValue = if (isFullScreen) 0f else 1f,
        animationSpec = tween(durationMillis = 600),
        label = "alpha",
    )

    val layoutDirection = LocalLayoutDirection.current
    val isLtr = layoutDirection == LayoutDirection.Ltr

     Box(
        modifier =
            modifier
                .fillMaxSize()

                .focusRestorer(tvChannelsFocusRequester)
                .padding(start = if (isFullScreen) 0.dp else mainLayoutStartPadding),


        content = {


            Box(Modifier.fillMaxSize()) {
                // 📺 TV Channels - slides in from left

                TvCategoriesTvList(
                    modifier = Modifier

                        .fillMaxHeight()

                        .layout { measurable, constraints ->
                            val w = (layoutWidth.toPx() * 0.25f).toInt()
                            val placeable =
                                measurable.measure(constraints.copy(minWidth = w, maxWidth = w))
                            layout(placeable.width, placeable.height) {
                                placeable.placeRelative(
                                    0,
                                    0
                                )
                            }
                        }
                        .graphicsLayer {
                            translationX =
                                if (isLtr) -size.width * slideProgress else size.width * slideProgress
                            alpha = alphaValue
                        },
                    playingCategory = playingCategoryState,

                    streamControlViewModel = streamControlViewModel,
                    onSameItemSelected = {
                        // panelState = PanelState.WithChannels
                        tvChannelsFocusRequester.requestFocus()
                    },
                    categoriesUiState = categoriesUiState,
                    isFullScreen = isFullScreen


                )

                Box ( Modifier
                    .fillMaxHeight()
                    .layout { measurable, constraints ->
                        val w = (layoutWidth.toPx() * 0.3f).toInt()
                        val offsetX = (layoutWidth.toPx() * 0.25f).toInt()
                        val placeable = measurable.measure(constraints.copy(minWidth = w, maxWidth = w))
                        layout(placeable.width, placeable.height) {
                            placeable.placeRelative(offsetX, 0)
                        }
                    }
                    .graphicsLayer {
                        translationX = if (isLtr) -size.width * slideProgress else size.width * slideProgress
                        alpha = alphaValue
                    }
                    /*.focusProperties{
                        canFocus = isFullScreen
                    }*/
                    /*.focusProperties {
                       IMPORTANT_UNCOMMENT_IN_NEXT_UPDATES onEnter= {
                            if (!isFullScreen)
                                panelState = PanelState.WithChannels

                        }
                    }*/
                    .focusRequester(tvChannelsFocusRequester)
                    //.focusGroup()

                ){
                    TvChannelsTvList(
                         requestFocusOnStart=requestFocusOnStart,
                        onSameItemClicked = {
                            panelState = PanelState.PlayerWithController

                        },
                        modifier =Modifier.fillMaxSize()
                        ,

                        streamControlViewModel = streamControlViewModel,
                        streamState = streamState,
                        isFavorite = isFavorite,
                        isFullScreen = isFullScreen,
                        playingCategory = playingCategoryState

                        )
                }



                Column(
                    modifier = Modifier
                        .fillMaxHeight()
                        //.width(200.dp)
                        .align(Alignment.TopEnd)
                        .layout { measurable, constraints ->
                            // 1. Calculate the animated container width
                            val totalW = layoutWidth.toPx()
                            val minW = totalW * 0.45f
                            val currentW = (minW + (totalW - minW) * playerExpansionProgress).toInt()

                            // 2. Define the Aspect Ratio (16:9)
                            val ratio = 16f / 9f

                            // 3. Measure the player
                            // If full screen (progress == 1f), fill the whole container.
                            // Otherwise, maintain 16:9 based on the current width.
                            val playerHeight = if (playerExpansionProgress < 1f) {
                                (currentW / ratio).toInt().coerceAtMost(constraints.maxHeight)
                            } else {
                                constraints.maxHeight
                            }

                            val placeable = measurable.measure(
                                constraints.copy(
                                    minWidth = currentW,
                                    maxWidth = currentW,
                                    minHeight = playerHeight,
                                    maxHeight = playerHeight
                                )
                            )

                            // 4. Position the player vertically centered in the Column
                            layout(currentW, constraints.maxHeight) {
                                val yOffset = 0// (constraints.maxHeight - placeable.height) / 2
                                placeable.placeRelative(0, yOffset)
                            }
                        }
                ) {
                    // BaseComposeMedia3Player and content...

/*
                // ▶️ Player - positioned at the right
                Column (
                    modifier = Modifier
                        .fillMaxHeight()
                        // .animateContentSize(tween(durationMillis = 700))

                        .width(animatedPlayerWidth*//*if(isFullScreen) width else width *.6f*//*)

                        .align(Alignment.CenterEnd) // Stick to right

                ) {*/


                      BaseComposeMedia3Player (
                        url = uri?:"" ,
                        modifier = Modifier
                           .padding(if (isFullScreen) 0.dp else 8.dp)
                            .clip(RoundedCornerShape(if (isFullScreen) 0.dp else 8.dp))
                            .onKeyEvent {
                                keyEvent(it)
                            }
                            //.focusable(true)
                           .focusRequester(playerFocusRequester)
                            .focusProperties {
                                canFocus = isFullScreen
                                    //panelState == PanelState.PlayerOnly || panelState == PanelState.PlayerWithController
                            }
                            ,
                        title = stringResource(Res.string.tv_channels),
                        onScreenResizeClicked = {

                            /*scope.launch {
                                val updatedScale = activity?.updateVideoScalingMode()
                                updatedScale?.let {
                                    snackbarHostState.currentSnackbarData?.dismiss()
                                    snackbarHostState.showSnackbar(
                                        message = updatedScale,

                                        )
                                }

                            }*/

                        },
                        controllersUI = {show, resetVisibilityRequester, showRequester, hideRequester->
                            if (!isFullScreen)
                                hideRequester.invoke()
                            if(resetVisibility==null)
                                resetVisibility = resetVisibilityRequester
                            if (show && panelState == PanelState.PlayerOnly)
                                panelState = PanelState.PlayerWithController




                            if (panelState == PanelState.PlayerWithController && show)

                                Dialog(


                                    onDismissRequest = {
                                         hideRequester()
                                        panelState = PanelState.PlayerOnly
                                    },
                                    properties = DialogProperties(
                                        usePlatformDefaultWidth = false // allows full-width or custom sizing
                                    )
                                )
                                {

                                    CompositionLocalProvider(LocalLayoutDirection provides LayoutDirection.Ltr) {

                                        // 🚀 Strips out the window dimming effects (Runs on Android, clean no-op on iOS)
                                        ConfigureDialogWindowProperties()
                                        Box(
                                            modifier = Modifier
                                                .fillMaxSize()
                                                .background(Color.Transparent)
                                                .onKeyEvent { keyEvent(it) },
                                        ) {
                                            TvChannelInfo(
                                                modifier = Modifier
                                                    .fillMaxWidth()
                                                    .align(Alignment.BottomCenter),
                                                streamControlViewModel = streamControlViewModel,
                                                appSettingsViewModel = appSettingsViewModel,
                                                streamState = streamState,
                                                isFavorite = isFavorite,
                                                requestFocusOnShow = true,
                                                onMenuControlClicked = {
                                                    panelState = PanelState.WithChannels
                                                }


                                            )
                                        }

                                    }
                                }
                        },
                        onNavigationIconClick = {}
                    )


                }




            }
        }


    )



    BackHandler(enabled = isFullScreen) {
         panelState = PanelState.WithChannels
    }


    LaunchedEffect(Unit) {


        with(streamControlViewModel) {
            val stream = streamId.let {
                //val lastPlayedCategory= appSettingsViewModel.lastPlayedCategory()?.toLiveCategoryOrNull()
                val requiredStreamID=it?: appSettingsViewModel.lastPlayedStream()?.toLiveStreamOrNull()?.streamId
                getStreamById(requiredStreamID)

            }?:findStreamByIndex( 0, AllConst.ALL_CATEGORIES_ID.toInt())

                val pos = this.indexOf(stream?.streamId ?: -1, stream?.categoryId ?: -1)
                emitSelectedTvChannel(pos, stream)

        }


    }
    LaunchedEffect(categoryId) {
        val category = categoryId?.let { streamControlViewModel.getCategory(it) }
        with(streamControlViewModel) {
            emitPlayingCategory(category)
        }
    }

    LaunchedEffect(streamState) {
        with(appSettingsViewModel) {
            setLastPlayedScreen(navKey::class.simpleName)
            setLastPlayedCategory(Json.safeEncodeToString(playingCategoryState))
            setLastPlayedStream(Json.safeEncodeToString(streamState))
        }
    }


    DisposableEffect(Unit) {
        onDispose {
            with(appSettingsViewModel) {
                setLastPlayedScreen(null)
                setLastPlayedCategory(null)
                setLastPlayedStream(null)
            }
        }
    }
}



